"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _react = _interopRequireWildcard(require("react"));
var _Wapp = require("wapplr-react/dist/common/Wapp");
var _withMaterial = require("common-components/dist/common/components/Template/withMaterial");
var _context = _interopRequireDefault(require("common-components/dist/common/components/App/context"));
var _reactMarkdown = _interopRequireDefault(require("react-markdown"));
var _reactSyntaxHighlighter = require("react-syntax-highlighter");
var _okaidia = _interopRequireDefault(require("react-syntax-highlighter/dist/cjs/styles/prism/okaidia"));
var _context2 = _interopRequireDefault(require("../Artwork/context"));
var _materialStyle = _interopRequireDefault(require("./materialStyle"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _OpenInNew = _interopRequireDefault(require("@mui/icons-material/OpenInNew"));
var style = require("./style_css.js")["default"];
var renderers = {
  code: function code(_ref) {
    var language = _ref.language,
      value = _ref.value;
    return /*#__PURE__*/_react["default"].createElement(_reactSyntaxHighlighter.Prism, {
      style: _okaidia["default"],
      language: language,
      children: value
    });
  }
};
function Description() {
  var _data$settings, _data$settings$basic_, _data$settings2, _data$settings2$basic;
  var context = (0, _react.useContext)(_Wapp.WappContext);
  var appContext = (0, _react.useContext)(_context["default"]);
  var messages = appContext.messages;
  var wapp = context.wapp;
  var artworkContext = (0, _react.useContext)(_context2["default"]);
  var data = artworkContext.data,
    translate = artworkContext.translate;
  wapp.styles.use(style);
  var description = translate(data === null || data === void 0 ? void 0 : (_data$settings = data.settings) === null || _data$settings === void 0 ? void 0 : (_data$settings$basic_ = _data$settings.basic_settings) === null || _data$settings$basic_ === void 0 ? void 0 : _data$settings$basic_.description) || "";
  var name = translate(data === null || data === void 0 ? void 0 : (_data$settings2 = data.settings) === null || _data$settings2 === void 0 ? void 0 : (_data$settings2$basic = _data$settings2.basic_settings) === null || _data$settings2$basic === void 0 ? void 0 : _data$settings2$basic.name) || "Artwork";
  var defaultDescription = translate(messages.defaultDescription);
  var container = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (container.current) {
      var aa = container.current.getElementsByTagName("a");
      for (var i = 0; i < aa.length; i++) {
        if (aa[i].getAttribute("href").startsWith("http")) {
          aa[i].setAttribute("target", "_blank");
        }
      }
    }
  }, [container]);
  function _onClick(e, menu) {
    if (wapp.parentWapp) {
      e.preventDefault();
      var href = menu.href;
      wapp.parentWapp.client.history.push((0, _objectSpread2["default"])({
        search: "",
        hash: ""
      }, wapp.client.history.parsePath(href)));
    }
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: style.description,
    ref: container
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.content
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactMarkdown["default"], {
    renderers: renderers
  }, [name ? "### " + name : "", description || defaultDescription].filter(function (t) {
    return t;
  }).join("\n\n"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.buttons
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: function onClick(e) {
      return _onClick(e, {
        href: wapp.parentWapp ? appContext.routes.moreArtworksRoute : "https://carco.hu" + appContext.routes.moreArtworksRoute
      });
    },
    href: wapp.parentWapp ? appContext.routes.moreArtworksRoute : "https://carco.hu" + appContext.routes.moreArtworksRoute,
    variant: "contained",
    color: "secondary",
    startIcon: /*#__PURE__*/_react["default"].createElement(_OpenInNew["default"], null),
    target: wapp.parentWapp ? "_self" : "_blank"
  }, translate(appContext.menus.moreArtworksMenu)), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: function onClick(e) {
      return _onClick(e, {
        href: wapp.parentWapp ? "/" : "https://carco.hu/"
      });
    },
    href: wapp.parentWapp ? "/" : "https://carco.hu/",
    variant: "contained",
    color: "secondary",
    startIcon: /*#__PURE__*/_react["default"].createElement(_OpenInNew["default"], null),
    target: wapp.parentWapp ? "_self" : "_blank"
  }, translate(appContext.menus.homeMenu)))));
}
var WappComponent = (0, _Wapp.withWapp)(Description);
var StyledComponent = (0, _withMaterial.withMaterialStyles)(_materialStyle["default"], WappComponent);
var _default = StyledComponent;
exports["default"] = _default;